import moment from 'moment'
import FormatHelper from './formats'

export default {
  add: add,
  addDays: addDays,
  subtractDays: subtractDays,
  durationInFormat: durationInFormat,
  format: format,
  formatTimestamp: formatTimestamp,
  getDuration: getDuration,
  getDurationInFormat: getDurationInFormat,
  getEventType: getEventType,
  toTimestamp: toTimestamp,
  getHoursMinutes: getHoursMinutes,
  getRelative: getRelative,
  nowString: nowString,
  nowStringLocal: nowStringLocal,
  daysToMs: daysToMs,
  guid: guid,
  getStartOfDay: getStartOfDay,
  getEndOfDay: getEndOfDay
}

/**
   * Add time
   * @param {String} datetime - ISO format
   * @param {Integer} add
   * @param {String} unit for adding
   * @return {}
   */
function add (datetime, add, unit = 's') {
  return moment(datetime).add(add, unit).format()
}

function addDays (datetime, days) {
  return moment(datetime).add(days, 'days')
}

function subtractDays (datetime, days) {
  return moment(datetime).subtract(days, 'days')
}

function durationInFormat (duration, format = 'ms') {
  return moment(duration).utc().format(format)
}

/**
* Format ISO date time
* @param {String} datetime - ISO format
* @param {String} format - Desired return format
*/
function format (datetime, format) {
  return moment(datetime).format(format)
}

/**
 * Format timestamp
 * @param {Number} timestamp
 * @param {String} format
 * @returns {*|moment.Moment}
 */
function formatTimestamp (timestamp, format) {
  return moment(timestamp).format(format)
}

/**
 * Return duration in desired unit
 * @param {String} startDateTime
 * @param {String} endDateTime
 * @param {String} unit
 * @return {Integer}
 */
function getDuration (startDateTime, endDateTime, unit = 'm') {
  let duration = moment.duration(moment(endDateTime).diff(moment(startDateTime)))
  switch (unit) {
    case 's':
      duration = duration.asSeconds()
      break
    case 'm':
      duration = duration.asMinutes()
      break
    case 'ms':
      duration = duration.asMilliseconds()
      break
    default:
      duration = duration.asMinutes()
  }
  return FormatHelper.formatDecimal(duration)
}

function getDurationInFormat (startDateTime, endDateTime, format = 'HH:mm') {
  let a = moment(endDateTime)
  let b = moment(startDateTime)
  return moment(a.diff(b)).utc().format(format)
}

/**
 * Compare two dates
 * @param {Number} dateOne
 * @param {Number} dateTwo
 * @param {Number} now - Now time
 */
function getEventType (startTime, endTime, now = 0) {
  if (now === 0) {
    now = (new Date()).getTime()
  }

  if (startTime <= now && endTime >= now) {
    return 'live'
  }

  if (now < startTime) {
    return 'reminder'
  }

  if (now > endTime) {
    return 'cutv'
  }
}

/**
 * Convert ISO date time to timestamp in milliseconds
 * @param {ISO datetime} datetime
 * @return {Integer} timestamp
 */
function toTimestamp (datetime = null) {
  if (datetime === null) {
    return parseInt(moment().format('x'))
  } else {
    return parseInt(moment(datetime).format('x'))
  }
}

/**
   * Return time in format HH:mm eg 14:05
   * @param {String} datetime
   * @return {String}
   */
function getHoursMinutes (datetime = null) {
  if (datetime === null) {
    return moment().utc().format('HH:mm')
  } else {
    return moment(datetime).format('HH:mm')
  }
}

function getRelative (datetime = null, formats) {
  if (datetime === null) {
    datetime = moment()
  } else {
    datetime = moment(datetime)
  }

  return datetime.calendar(moment(), {
    nextWeek: 'DD.MM.YYYY',
    lastWeek: 'DD.MM.YYYY',
    sameElse: 'DD.MM.YYYY'
  })
}

/**
 * Return current date and time as String
 * @return {String}
 */
function nowString (format = null) {
  if (format === null) {
    return moment().utc().format()
  } else {
    return moment().utc().format(format)
  }
}

function nowStringLocal (format = null) {
  if (format === null) {
    return moment().format()
  } else {
    return moment().format(format)
  }
}

/**
 * Convert days to duration in milliseconds
 * @param {number} numberOfDays
 */
function daysToMs (numberOfDays = 0) {
  return numberOfDays * 24 * 60 * 60 * 1000
}

/**
 * Create guid
 * @returns {string}
 */
function guid () {
  function s4 () {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1)
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    s4() + '-' + s4() + s4() + s4()
}

/**
 * Get start of day with offset
 * @param {number} offset - Offset in milliseconds
 * @returns {number} - Return time in milliseconds
 */
function getStartOfDay (offset = 0) {
  if (typeof offset !== 'number') {
    offset = 0
  }
  return new Date().setHours(0, 0, 0, 0) - offset
}

/**
 * Get end of day with offset
 * @param {number} offset - Offset in milliseconds
 * @returns {number}
 */
function getEndOfDay (offset = 0) {
  if (typeof offset !== 'number') {
    offset = 0
  }
  return new Date().setHours(23, 59, 59, 999) - offset
}



// WEBPACK FOOTER //
// ./src/helpers/date.js